import React, { useState, useEffect, useMemo } from "react";
import { putPersona } from "../helpers/rutaPersonas";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades"; // opcional si querés el select

const ModalFormPersona = ({ persona, handleClose }) => {
  // Normaliza el shape: puede venir como persona.persona, persona.personas o el objeto directo
  const initial = useMemo(() => {
    const src =
      persona?.persona ||
      persona?.personas ||
      persona ||
      {};
    return {
      _id: src._id || "",
      codper: src.codper || "",
      nombre: src.nombre || "",
      domicilio: src.domicilio || "",
      telefono: src.telefono || "",
      email: src.email || "",
      localidad: typeof src.localidad === "object" ? src.localidad?._id || "" : (src.localidad || ""),
      perfil: (src.perfil || "EMPLEADO").toUpperCase(),
      activo: typeof src.activo === "boolean" ? src.activo : true,
    };
  }, [persona]);

  const [formValues, setFormValues] = useState(initial);

  useEffect(() => {
    setFormValues(initial);
  }, [initial]);

  const [localidades, setLocalidades] = useState({ data: [], loading: true, error: null });
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const resp = await getLocalidades();
        const data = resp?.localidades || resp?.data?.localidades || resp?.data || [];
        if (alive) setLocalidades({ data, loading: false, error: null });
      } catch (e) {
        if (alive) setLocalidades({ data: [], loading: false, error: e?.message || "Error al cargar localidades" });
      }
    })();
    return () => { alive = false; };
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!formValues._id) throw new Error("Falta el ID de la persona");
      const payload = {
        nombre: formValues.nombre,
        domicilio: formValues.domicilio,
        telefono: formValues.telefono,
        email: formValues.email,
        localidad: formValues.localidad || null,
        perfil: formValues.perfil,
        activo: formValues.activo,
      };
      const resp = await putPersona(formValues._id, payload);
      console.log("Persona actualizada:", resp);
      handleClose();
    } catch (err) {
      console.error("Error actualizando persona:", err);
      // acá podés disparar un toast/alert
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Modal.Body>
        <div className="form-group mt-2">
          <label>Nombre</label>
          <input
            type="text"
            className="form-control"
            name="nombre"
            maxLength={100}
            required
            value={formValues.nombre}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <div className="form-group mt-3 col-sm-7">
            <label>Domicilio</label>
            <input
              type="text"
              className="form-control"
              name="domicilio"
              maxLength={100}
              value={formValues.domicilio}
              onChange={handleChange}
            />
          </div>
          <div className="form-group mt-3 col-sm-5">
            <label>Teléfono</label>
            <input
              type="text"
              className="form-control"
              name="telefono"
              maxLength={30}
              value={formValues.telefono}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group mt-3 col-sm-6">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              maxLength={50}
              value={formValues.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3 col-sm-4">
            <label>Localidad</label>
            <select
              className="form-control"
              name="localidad"
              value={formValues.localidad}
              onChange={handleChange}
            >
              <option value="">Elija opción</option>
              {!localidades.loading &&
                localidades.data.map((loc) => (
                  <option key={loc._id} value={loc._id}>
                    {loc.descripcion || loc.localidad || "Sin nombre"}
                  </option>
                ))}
            </select>
            {localidades.error && (
              <small className="text-danger">{localidades.error}</small>
            )}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group mt-3 col-sm-4">
            <label>Perfil</label>
            <select
              className="form-control"
              name="perfil"
              value={formValues.perfil}
              onChange={handleChange}
              required
            >
              <option value="EMPLEADO">EMPLEADO</option>
              <option value="SOCIO">SOCIO</option>
            </select>
          </div>

          <div className="form-group mt-4 col-sm-3 d-flex align-items-center">
            <div className="form-check">
              <input
                id="chkActivo"
                className="form-check-input"
                type="checkbox"
                name="activo"
                checked={formValues.activo}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="chkActivo">
                Activo
              </label>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button type="submit" variant="dark">
          Guardar
        </Button>
      </Modal.Footer>
    </form>
  );
};

export default ModalFormPersona;
